import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2, MapPin } from 'lucide-react';
const buyers = [{
  name: 'Carlos',
  city: 'Madrid',
  time: 'Hace 2 horas'
}, {
  name: 'Ana',
  city: 'Buenos Aires',
  time: 'Hace 1 hora'
}, {
  name: 'Diego',
  city: 'México DF',
  time: 'Hace 3 horas'
}, {
  name: 'María',
  city: 'Bogotá',
  time: 'Hace 45 minutos'
}, {
  name: 'Pedro',
  city: 'Santiago',
  time: 'Hace 4 horas'
}];
export function SocialProofToast() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    // Initial delay before showing first toast
    const initialTimer = setTimeout(() => {
      setIsVisible(true);
    }, 5000);
    // Cycle toasts every 12 seconds (visible for 8s, hidden for 4s)
    const cycleInterval = setInterval(() => {
      setIsVisible(false);
      setTimeout(() => {
        setCurrentIndex(prev => (prev + 1) % buyers.length);
        setIsVisible(true);
      }, 4000); // Wait 4 seconds before showing next
    }, 12000);
    return () => {
      clearTimeout(initialTimer);
      clearInterval(cycleInterval);
    };
  }, []);
  const currentBuyer = buyers[currentIndex];
  return <AnimatePresence data-id="element-269">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      scale: 0.9
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} transition={{
      duration: 0.4
    }} className="fixed bottom-4 left-4 z-50 bg-zinc-900 border border-zinc-800 rounded-lg shadow-2xl p-3 flex items-start gap-3 max-w-[280px] sm:max-w-sm" data-id="element-270">
          <div className="bg-amber-500/10 p-1.5 rounded-full mt-0.5 shrink-0" data-id="element-271">
            <CheckCircle2 className="w-4 h-4 text-amber-500" data-id="element-272" />
          </div>
          <div data-id="element-273">
            <p className="text-sm font-bold text-white" data-id="element-274">
              {currentBuyer.name} — {currentBuyer.city}
            </p>
            <p className="text-[11px] sm:text-xs text-zinc-400 mt-0.5 leading-tight" data-id="element-275">
              Acaba de comprar el Fotógrafo Pro Kit
            </p>
            <div className="flex items-center gap-1 mt-1.5 text-[9px] sm:text-[10px] text-zinc-500 uppercase tracking-wider font-semibold" data-id="element-276">
              <MapPin className="w-2.5 h-2.5" data-id="element-277" />
              {currentBuyer.time} • Verificado
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}